import request from '@/utils/request'

export function getSellOrderList(data) {
  return request.post('/sell-order/list', data)
}

export function addSellOrder(data) {
  return request.post('/sell-order/add', data)
}

export function modifySellOrder(data) {
  return request.post('/sell-order/modify', data)
}

export function deleteSellOrder(data) {
  return request.post('/sell-order/delete', data)
}

export function arrivedSellOrder(data) {
  return request.post('/sell-order/arrived', data)
}

export function takeDeliveryOfSellOrder(data) {
  return request.post('/sell-order/take-delivery', data)
}

export function issuedSellOrder(data) {
  return request.post('/sell-order/issued', data)
}

export function completeSellOrder(data) {
  return request.post('/sell-order/complete', data)
}

export function cancelSellOrder(data) {
  return request.post('/sell-order/cancel', data)
}

export function listByGoods(data) {
  return request.post('/sell-order/list-by-goods', data)
}

export function getImportLogList(data) {
  return request.post('/e-commerce-import-log/list', data)
}

export function reportByDate(data) {
  return request.post('/sell-report/by-date', data)
}



// WEBPACK FOOTER //
// ./src/api/sell/order.js